(function () {
  var KEY = 'pq-wishlist';
  function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function sync() {
    var list = get();
    document.querySelectorAll('[data-pq-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-pq-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-pq-wish-count]').forEach(function (c) { c.textContent = list.length; });
    document.dispatchEvent(new CustomEvent('pq:wishlist', { detail: list }));
  }
  function set(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} sync(); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pq-wish]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var list = get(), h = b.getAttribute('data-pq-wish'), i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.unshift(h);
    set(list);
  });
  window.PqWishlist = { get: get, set: set, sync: sync };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
